<template>
  <div
    class="flex w-full flex-row flex-wrap items-center justify-center bg-primary-500 px-8 py-5 md:flex-nowrap md:justify-between md:py-2"
  >
    <div class="flex flex-row flex-nowrap py-3">
      <UiLink
        v-for="social in cmsStore.footer?.copyright.socials"
        :id="`footer-social-${social.id}`"
        :key="social.id"
        :to="`${social.link}`"
        target="_blank"
        class="mx-3 size-6"
      >
        <UiImage
          :id="social.id.toString()"
          :src="social.logo?.url"
          :alt="social.logo?.alt_text ?? social.name"
          class="w-full"
        />
      </UiLink>
    </div>
    <div class="flex flex-col items-center justify-center md:flex-row md:flex-nowrap">
      <div class="space-x-3 py-3">
        <UiLink
          v-for="copyrightLink in cmsStore.footer?.copyright.links"
          :id="`footer-legal-${copyrightLink.id}`"
          :key="copyrightLink.id"
          :underline="false"
          :to="`${copyrightLink.url}`"
          size="sm"
          class="text-white"
        >
          {{ copyrightLink.name }}
        </UiLink>
        <UiText size="sm" class="text-white opacity-50">
          {{ cmsStore.footer?.copyright.copyright }}
        </UiText>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import { useCmsStore } from '~/stores/cms/cmsStore';

const cmsStore = useCmsStore();
</script>
